import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MailCheckedFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 17.5C11.25 14.3244 13.8244 11.75 17 11.75C20.1756 11.75 22.75 14.3244 22.75 17.5C22.75 20.6756 20.1756 23.25 17 23.25C13.8244 23.25 11.25 20.6756 11.25 17.5ZM19.4801 15.4238C19.7983 15.689 19.8413 16.1619 19.5762 16.4801L17.0762 19.4801C16.9413 19.642 16.7445 19.7397 16.534 19.7492C16.3235 19.7588 16.1187 19.6793 15.9697 19.5303L14.4697 18.0303C14.1768 17.7374 14.1768 17.2626 14.4697 16.9697C14.7626 16.6768 15.2374 16.6768 15.5303 16.9697L16.4496 17.8889L18.4238 15.5199C18.689 15.2017 19.1619 15.1587 19.4801 15.4238Z"
				fill="currentColor"
			/>
			<path
				d="M20 2.75C21.5188 2.75 22.75 3.98122 22.75 5.5V13.5088C21.4857 11.6907 19.3823 10.5 17 10.5C13.134 10.5 10 13.634 10 17.5C10 18.4763 10.2005 19.4057 10.5615 20.25H4C2.48122 20.25 1.25 19.0188 1.25 17.5V5.5C1.25 3.98122 2.48122 2.75 4 2.75H20ZM18.6475 6.12207C18.4518 5.78687 18.0363 5.65926 17.6904 5.81641L17.6221 5.85254L12.6299 8.76465C12.2407 8.99159 11.7593 8.99159 11.3701 8.76465L6.37793 5.85254L6.30957 5.81641C5.96367 5.65926 5.54819 5.78687 5.35254 6.12207C5.15694 6.45738 5.25054 6.88168 5.55762 7.10547L5.62207 7.14746L10.6143 10.0596C11.4705 10.559 12.5295 10.559 13.3857 10.0596L18.3779 7.14746L18.4424 7.10547C18.7495 6.88168 18.8431 6.45738 18.6475 6.12207Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MailCheckedFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MailCheckedFilledIcon;
